import PlaylistCollectionPage from './PlaylistCollectionPage';
import _PlaylistPage from './PlaylistPage';

export const PlaylistPage = _PlaylistPage;
export default PlaylistCollectionPage;
